// Cloudfront for junglescoutpro bucket that lives in "Greg Mercer" AWS Account
export const JSPRO_BUCKET = 'https://dh2wkbcb9yv3l.cloudfront.net'
